import * as Backbone from "backbone";
import {CachingCollection} from "./_BaseCollection";

interface ConversionFunctionCollectionOptions {
    moduleId: number
}

export class ConversionFunctionCollection extends CachingCollection<Backbone.Model> {

    moduleId: number;

    url = () => {
        return window.location.origin + '/api/v1/module/' + this.moduleId + '/conversionfunctions';
    };

    constructor(initialModels: Object[] | any[], options: ConversionFunctionCollectionOptions) {
        super(initialModels, options);
        this.moduleId = options.moduleId;
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/ConversionFunctions.ts